import { useState } from 'react';
import { NextSeo } from 'next-seo';
import styled from 'styled-components';
import { useForm } from 'react-hook-form';
import { useWindowSize } from 'react-use';

import fetcher from '@utils/fetcher';
import { useTranslation } from '@hooks';
import { useNotification } from '@context/NotificationContext';
import { contactUsSchema } from 'lib/validationSchemas';
import { InputWrapper } from 'components/common';
import { Caption2, H3, Subtitle1, Text3 } from 'components/styles/Typography';
import { BackButton, NewButton } from 'components/ui';
import {
    StaticPageWrapper,
    StaticPageContainer,
} from 'components/styles/StaticPagesStyles';
import {
    Checkbox,
    CheckboxContainer,
    CheckboxLabel,
} from '@components/styles/AuthStyles';
import { SignupTermsModal } from '@components/auth';
import { ContactUsAgreement } from '@components/contracts';
import PageHeader from '@components/common/Header/PageHeader';

const { yupResolver } = require('@hookform/resolvers/yup');

const sendForm = (data, setResponse) => {
    const options = {
        method: 'POST',
        body: JSON.stringify({
            first_name: data.name,
            last_name: data.surname,
            email: data.email,
            message: data.message,
        }),
    };
    fetcher('v1/contact/send-email', options)
        .then((response) => {
            setResponse(response);
        })
        .catch((error) => {
            throw new Error('Contact Form Error', error);
        });
};

const Contact = () => {
    const { t, locale } = useTranslation();
    const { open } = useNotification();
    const { width } = useWindowSize();
    const [response, setResponse] = useState(null);
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(contactUsSchema),
    });

    const onSubmit = async (data) => {
        await sendForm(data, setResponse);
        if (response?.success) {
            open({
                type: 'success',
                title: t('contactNotifyTitle'),
                description: t('contactNotifyTitle'),
            });
        }
        reset();
        window.scrollTo({
            top: 100,
            left: 0,
            behavior: 'smooth',
        });
    };
    return (
        <div>
            <NextSeo
                title={`Fervente | ${t('footerContact')}`}
                description={t('contactMetaDesc')}
            />
            <PageHeader title={t('contact')} />
            <StaticPageWrapper marginTopMobile="90px">
                <BackButton title={t('contact')} tabletHide />
                <TitleWrapper>
                    <H3>{t('addresses')}</H3>
                </TitleWrapper>
                <Cols>
                    <div>
                        <Subtitle1>{t('headOfficeAddressTitle')}</Subtitle1>
                        <Text3>
                            284 Chase Road <br />
                            A Block 2nd Floor <br />
                            London - England N14 6HF
                        </Text3>
                    </div>
                    <div>
                        <Subtitle1>{t('factoryAddressTitle')}</Subtitle1>
                        <Text3>
                            Dolapdere Cad. Küçükbayır Sok. <br />
                            No:119/A Şişli - <br />
                            İstanbul - TÜRKİYE
                        </Text3>
                    </div>
                    <div>
                        <Subtitle1>{t('contactWorkingHours')}</Subtitle1>
                        <Text3>
                            {t('monday')} - {t('friday')}: 09:30 - 19:00
                        </Text3>
                    </div>
                </Cols>
                {width > 1024 && (
                    <>
                        <TitleWrapper>
                            <H3>{t('contactUs')}</H3>
                        </TitleWrapper>
                        <Cols>
                            <div>
                                <Subtitle1>{t('phone')} :</Subtitle1>{' '}
                                <Text3>
                                    +90 212 248 81 11
                                </Text3>
                            </div>
                            <div>
                                <Subtitle1>{t('callCenter')} :</Subtitle1>{' '}
                                <Text3>
                                    +90 545 260 10 81
                                </Text3>
                            </div>
                            <div>
                                <Subtitle1>{t('email')} :</Subtitle1>
                                <Text3>destek@ferventeshop.com</Text3>
                            </div>
                        </Cols>
                    </>
                )}

                {/*
                        <ContactInfoContainer>
                            <H3>{t('addresses')}</H3>
                            <Subtitle1>{t('headOfficeAddressTitle')}</Subtitle1>
                            <Text3>
                                284 Chase Road <br /> <br />
                                A Block 2nd Floor <br /> <br />
                                London - England N14 6HF
                            </Text3>
                            <Subtitle1>{t('factoryAddressTitle')}</Subtitle1>
                            <Text3>
                                Dolapdere Cad. Küçükbayır Sok. <br /> <br />
                                No:119/A Şişli - <br /> <br />
                                İstanbul - TÜRKİYE
                            </Text3>
                        </ContactInfoContainer>
                        <ContactInfoContainer>
                            <H3>{t('contactUs')}</H3>
                            <Text3>
                                <Subtitle1>{t('phone')} :</Subtitle1>{' '}
                                {locale === 'en'
                                    ? '+442045771997'
                                    : `+90 850
                                259 14 41`}
                                <br />
                                <br />
                                <Subtitle1>{t('email')} :</Subtitle1>{' '}
                                destek@ferventeshop.com
                            </Text3>
                        </ContactInfoContainer>
                        <ContactInfoContainer>
                            <Subtitle1>{t('contactWorkingHours')}</Subtitle1>
                            <Text3>
                                {t('monday')} - {t('friday')}: 09:30 - 19:00
                            </Text3>
                        </ContactInfoContainer> */}
                <ContactNotificationContainer />
                {width < 1024 && (
                    <TitleWrapper>
                        <H3>{t('contactUs')}</H3>
                    </TitleWrapper>
                )}

                <StaticPageContainer>
                    {width < 1024 && (
                        <Cols noSpace>
                            <div>
                                <Subtitle1>{t('phone')}</Subtitle1>{' '}
                                <Text3>
                                    {locale === 'en'
                                        ? '+442045771997'
                                        : `+90 850
                                259 14 41`}
                                </Text3>
                            </div>
                            <div>
                                <Subtitle1>{t('email')}</Subtitle1>
                                <Text3>destek@ferventeshop.com</Text3>
                            </div>
                        </Cols>
                    )}
                    <TextWrapper>
                        <Text3>{t('contactInfoText')}</Text3>
                    </TextWrapper>
                    <ContactForm onSubmit={handleSubmit(onSubmit)}>
                        <ContactInputContainer>
                            <InputWrapper
                                width="220px"
                                mobile="100%"
                                placeholder={t('name')}
                                error={errors.name?.message}
                            >
                                <input {...register('name')} />
                            </InputWrapper>

                            <InputWrapper
                                width="220px"
                                mobile="100%"
                                placeholder={t('surname')}
                                error={errors.surname?.message}
                            >
                                <input {...register('surname')} />
                            </InputWrapper>
                            <InputWrapper
                                width="220px"
                                mobile="100%"
                                placeholder={t('email')}
                                error={errors.email?.message}
                            >
                                <input {...register('email')} />
                            </InputWrapper>
                        </ContactInputContainer>
                        <ContactInputContainer>
                            <InputWrapper
                                width="100%"
                                mobile="100%"
                                placeholder={t('contactMessage')}
                                error={errors.message?.message}
                            >
                                <input {...register('message')} />
                            </InputWrapper>
                        </ContactInputContainer>
                        <CheckboxContainer width="100%">
                            <Checkbox
                                type="checkbox"
                                {...register('allowAgreement')}
                            />
                            <CheckboxLabel error={errors.allowAgreement}>
                                {locale === 'tr' ? (
                                    <Caption2>
                                        E-posta ile tarafımıza ileteceğiniz
                                        kişisel verilerinizi firmamızın ticari
                                        ilişkileri ve tarafınızca iletişime
                                        geçilen amaçlar doğrultusunda
                                        işlemekteyiz.
                                        <br /> Detaylı bilgi için{' '}
                                        <SignupTermsModal
                                            title={t('contactAgreement')}
                                            content={<ContactUsAgreement />}
                                        />
                                        `ni inceleyebilirsiniz.
                                    </Caption2>
                                ) : (
                                    <Caption2>
                                        We process your personal data, which you
                                        will send to us via e-mail, in line with
                                        the commercial relations of our company
                                        and the purposes communicated by you.
                                        <br /> For detailed information, you can
                                        review the{' '}
                                        <SignupTermsModal
                                            title={t('contactAgreement')}
                                            content={<ContactUsAgreement />}
                                        />
                                    </Caption2>
                                )}
                            </CheckboxLabel>
                        </CheckboxContainer>
                        <ContactButtonContainer>
                            <NewButton
                                size="xlarge"
                                type="primary"
                                content={t('send')}
                                handleClick={onSubmit}
                            />
                        </ContactButtonContainer>
                    </ContactForm>
                </StaticPageContainer>
            </StaticPageWrapper>
        </div>
    );
};

export default Contact;
const ContactInputContainer = styled.div`
    display: flex;
    justify-content: space-between;
    button {
        max-width: 305px;
        margin: 0 auto;
    }
    @media (max-width: 768px) {
        display: block;
        input {
            width: 100%;
            margin-bottom: 30px;
        }
    }
`;
const ContactButtonContainer = styled.div`
    margin: 30px auto 0;

    @media (max-width: 768px) {
        margin: 10px 0 0;
    }
`;

const ContactForm = styled.form`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    max-width: 1024px;
    border: ${({ theme }) => `1px solid ${theme.colors.bgGray10}`};
    padding: 40px;
    margin-bottom: 60px;

    @media (max-width: 768px) {
        border: none;
        padding: 15px 0 40px;
        height: 100%;
    }
`;

const ContactNotificationContainer = styled.div`
    max-width: 1024px;
    @media (max-width: 768px) {
        margin: 20px auto 0;
    }
`;

const TitleWrapper = styled.div`
    padding: 20px 0;
    @media (max-width: 1024px) {
        padding: 20px;
    }
`;
const Cols = styled.div`
    display: grid;
    justify-items: flex-start;
    position: relative;
    grid-template-columns: repeat(3, 1fr);

    @media (max-width: 1024px) {
        display: flex;
        flex-direction: column;
        margin: ${({ noSpace }) => (noSpace ? '0' : '0 20px')};
        padding: ${({ noSpace }) => (noSpace ? '0' : '20px')};
        background-color: ${({ theme }) => theme.colors.secondary};
        gap: 20px;
    }
`;
const TextWrapper = styled.div`
    margin: 20px 0;
`;
